import EditStrategicPlanContainer from "../containers/EditStrategicPlanContainer";

const EditStrategicPlanPage = () => {
  return (
    <EditStrategicPlanContainer />
  );
};

export default EditStrategicPlanPage;
